// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@ces/XDL/PreStyle/accordion";
import breadcrumbs from "@ces/XDL/PreStyle/breadcrumbs";
import breakpoints from "@ces/XDL/PreStyle/breakpoints";
import button from "@ces/XDL/PreStyle/button";
import checkbox from "@ces/XDL/PreStyle/checkbox";
import clickable from "@ces/XDL/PreStyle/clickable";
import colors from "@ces/XDL/PreStyle/colors";
import dataTable from "@ces/XDL/PreStyle/dataTable";
import datePicker from "@ces/XDL/PreStyle/datePicker";
import drawer from "@ces/XDL/PreStyle/drawer";
import dynamicDropdown from "@ces/XDL/PreStyle/dynamicDropdown";
import fieldSet from "@ces/XDL/PreStyle/fieldSet";
import fileUpload from "@ces/XDL/PreStyle/fileUpload";
import focus from "@ces/XDL/PreStyle/focus";
import footer from "@ces/XDL/PreStyle/footer";
import formField from "@ces/XDL/PreStyle/formField";
import globalStyle from "@ces/XDL/PreStyle/globalStyle";
import header from "@ces/XDL/PreStyle/header";
import helpers from "@ces/XDL/PreStyle/helpers";
import icon from "@ces/XDL/PreStyle/icon";
import lazyImage from "@ces/XDL/PreStyle/lazyImage";
import link from "@ces/XDL/PreStyle/link";
import lists from "@ces/XDL/PreStyle/lists";
import loadingSpinner from "@ces/XDL/PreStyle/loadingSpinner";
import menu from "@ces/XDL/PreStyle/menu";
import modal from "@ces/XDL/PreStyle/modal";
import overflowMenu from "@ces/XDL/PreStyle/overflowMenu";
import pagination from "@ces/XDL/PreStyle/pagination";
import panelMenu from "@ces/XDL/PreStyle/panelMenu";
import radio from "@ces/XDL/PreStyle/radio";
import select from "@ces/XDL/PreStyle/select";
import shadows from "@ces/XDL/PreStyle/shadows";
import swatch from "@ces/XDL/PreStyle/swatch";
import tab from "@ces/XDL/PreStyle/tab";
import tag from "@ces/XDL/PreStyle/tag";
import tagsField from "@ces/XDL/PreStyle/tagsField";
import textArea from "@ces/XDL/PreStyle/textArea";
import textField from "@ces/XDL/PreStyle/textField";
import toast from "@ces/XDL/PreStyle/toast";
import tokenExFrame from "@ces/XDL/PreStyle/tokenExFrame";
import tooltip from "@ces/XDL/PreStyle/tooltip";
import typography from "@ces/XDL/PreStyle/typography";
import zIndex from "@ces/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@ces/XDL/types";

export default {
    breakpoints,
    button,
    colors,
    globalStyle,
    typography,
    zIndex,
    focus,
    accordion,
    breadcrumbs,
    checkbox,
    clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    fileUpload,
    header,
    formField,
    footer,
    fieldSet,
    icon,
    link,
    lists,
    lazyImage,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    swatch,
    shadows,
    tab,
    tag,
    tagsField,
    textField,
    tokenExFrame,
    textArea,
    toast,
    tooltip,
    helpers,
} as xBaseTheme;
